import React from 'react';
import ReactDOM from 'react-dom';
import FsPlayer from '../../shared/components/FsPlayer';
import VideoModalList from '../../videoPlayer/components/VideoPlaylist';
import { loadVideoPlayer } from '../../shared/services/VideoPlayerService';
import { icons } from '../../shared/styles/icons';
import { styles } from './styles/VideoModalStyles';
import { css } from 'aphrodite/no-important';
import FsPlaylistService from '../../shared/services/FsPlaylistService';
import VideoModalShare from '../../videoPlayer/components/VideoShare';
import Viewports from '../../../assets/components/fsUtils/Viewports';
import ScreenLock from '../../../assets/components/fsUtils/screenLock';
import { playerStyles } from '../../videoPlayer/components/styles/VideoPlayerStyles';
import { getPostId } from '../../shared/utils';


class VideoModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            showModal: true,
            topVideos: [],
            width: window.innerWidth,
            releaseUrl: '',
            currentPost: null,
            displayDetails: true,
        };

        this.viewport = new Viewports({
            'mobile': 767,
            'desktop': 1024
        });

        this.isPlaying = false;
        this.modalCont = document.getElementById('video-player-modal');
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.category = this.props.category;
        this.title = this.props.title;
        this.pubDate = this.props.pubDate;
        this.videoConfig = this.props.videoConfig;
        this.videoConfigObject = JSON.parse(this.videoConfig);
        this.limit = 7;
        this.post = {
            title: this.title,
            pubDate: this.pubDate,
            videoConfig: this.videoConfig,
            videoUrl: this.props.videoUrl
        }
        this.playerMetaHeight = 0;
        
        //sets up callback which returns post meta of the clicked video 
        this.updateCurrentPost = this.updateCurrentPost.bind(this);        
        this.updateDetails = this.updateDetails.bind(this);
        document.body.classList.add('video-modal-is-active');

        this.screenLock = new ScreenLock();

        this.screenLock.lockScreen();
    };

    updateCurrentPost(post) {
        this.setState({releaseUrl: post.releaseUrl, currentPost: post}); 
        let cPlayer = window.currentPlayer;
        if(cPlayer) {
            if(this.modalOverlay.scrollTop > 0) this.modalOverlay.scrollTop = 0;
            cPlayer.setReleaseCall(post.releaseUrl);

        }
    }

    updateDetails(e) {
        let el = this.playerMeta;
        if(this.viewport.isMobile || this.viewport.winW <= 767) {
            this.setState(() => ({
                displayDetails: e.target.scrollTop <= 0
        }))
        }
    }

    openModal() {
        this.setState({ showModal: true });
    }

    closeModal() {
        this.modalCont.style = 'display: none';
        document.body.classList.remove('video-modal-is-active');
        this.screenLock.unlockScreen();
        if( window.currentPlayer )  window.currentPlayer.setReleaseCall('');
        
        setTimeout(()=> {
            let modalCont = document.getElementById('video-player-modal');
            if(modalCont)  ReactDOM.unmountComponentAtNode(modalCont);
        }, 0);

    }

    componentDidMount() {
        const postId = getPostId();
        //fetch new top videos
        new FsPlaylistService().getMpxPlaylist( this.videoConfigObject.endcard_feed, this.limit, postId ).then( topVideos => {
            this.setState(() => ({
				topVideos: topVideos
            }))

        });

        if(this.playerMeta.clientHeight > 0){
            this.playerMetaHeight = this.playerMeta.clientHeight;
        }
        let modal = document.querySelector('#video-player-modal');
        let player = modal.querySelector('.fs-video-player');
        let playerCont = modal.querySelector('.vm-player-cont');

        setTimeout(()=> {
            loadVideoPlayer(player, playerCont.clientWidth, playerCont.clientHeight, null);
        }, 0);
    }   

    handleModalClose(e) {
        if (e.target.className.indexOf('overlayBg_') > -1 ) this.closeModal();
    }

    render() {
        const topVideos = this.state.topVideos;
        let post = this.state.currentPost || this.post;
        let playerMetaStyles = [playerStyles.playerMeta];
        if(!this.state.displayDetails){
            playerMetaStyles.push(styles.hideMeta);
        }
        return (
            <div>
                <div className={css(styles.overlayBg)} onClick={this.handleModalClose}>
                </div>
                <div ref={el => this.modalOverlay = el} className={css(styles.overlay)} onClick={this.handleModalClose}>
                    <div className={css(styles.modal)}>
                        <div className={css(styles.vmContainer)}>
                                <div className={css(styles.vmHeader)}>
                                    <span className={css(icons.icFs)}></span>
                                </div>
                            <div>
                                <a className={css(styles.closeButton)} onClick={this.closeModal}>
                                    <span className={css(icons.icCloseIconWhite)}></span>
                                </a>
                                <div className={css(playerStyles.videoCont) + ' vm-player-cont'}>
                                    <div className={css(playerStyles.playerSizes)}>
                                         <FsPlayer playerRef={'player ref'} playerConfig={post.videoConfig}/>
                                    </div>
                                    <div ref={elem => this.playerMeta = elem} className={css(playerMetaStyles)}>
                                        <div ref={el => this.metaCont = el}>
                                            <h2 className={css(playerStyles.title)}> {post.title} </h2>
                                            <span className={css(playerStyles.props)}>
                                                <span className={css(playerStyles.time)}>
                                                    {post.pubDate}
                                                </span>
                                                <span className={css(playerStyles.category)}>
                                                    {this.category}
                                                </span>
                                            </span>
                                            <VideoModalShare title={post.title} videoUrl={post.videoUrl} />
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div className={css(styles.vmMoreVideos)}>
                                {
                                    topVideos.length > 0 && 
                                        <VideoModalList title={this.category} videos={topVideos} enableShowMore={false}
                                            onClick={this.updateCurrentPost} showDetails={this.updateDetails} hideTitle={false}/> 
                                }
                                {/* <span className={css(styles.divider)} ></span> commenting for now, will be needed later */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default VideoModal;


// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/VideoModal.js